export default __webpack_public_path__ + "static/media/checklist.247207e6.png";